
<template>
    <div>
        <ValidationObserver ref="dateFinalization">
            <div class="col-12 col-md-6 col-lg-3 col-xl-3">
                <ValidationProvider name="confirmed_departure_date" rules="required" v-slot="{ valid, errors }">
                    <b-form-group :label="$t('confirmed_departure_date')">
                        <SelectDate :is-time="true" v-model=mentoraAdminStep.confirmed_departure_date :validation-error="errors[0]" />
                    </b-form-group>
                </ValidationProvider>
            </div>
            <div class="col-12 col-md-6 col-lg-3 col-xl-3">
                <ValidationProvider name="confirmed_return_date" rules="required"  v-slot="{ valid, errors }">
                    <b-form-group :label="$t('confirmed_return_date')">
                        <SelectDate :is-time="true" v-model=mentoraAdminStep.confirmed_return_date :validation-error="errors[0]" />
                    </b-form-group>
                </ValidationProvider>
            </div>
        </ValidationObserver>
    </div>
</template>
<script>
import OutOfCountryMentora from "@/services/OutOfCountryMentoraServices";

export default {
    name: "FinalizedDate",
    data(){
        return {
            isLoading:false,
            mentoraAdminStep:{
                confirmed_departure_date:null,
                confirmed_return_date:null
            }
        }
    },
    methods:{
        async dateFinalized(){
            const isValid = await this.$refs.dateFinalization.validate();
            if (!isValid) return false
            try {
                const data ={
                    confirmed_departure_date: this.mentoraAdminStep.confirmed_departure_date,
                    confirmed_return_date:this.mentoraAdminStep.confirmed_return_date
                }
                await OutOfCountryMentora.dateFinalized(this.$route.params.id,data)
                return true
            }catch (err){
                this.showErrors(err, this.$refs.dateFinalization)
                return  false
            }

        },
    }
}
</script>

<style scoped>

</style>
